import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "setting-up-the-wskdeploy-cli"
    }}>{`Setting up the wskdeploy CLI`}</h1>
    <p>{`To install `}<inlineCode parentName="p">{`wskdeploy`}</inlineCode>{`, you either use brew:`}</p>
    <pre><code parentName="pre" {...{}}>{`brew install wskdeploy
`}</code></pre>
    <p>{` or `}<a parentName="p" {...{
        "href": "https://github.com/apache/incubator-openwhisk-wskdeploy/releases"
      }}>{`download it`}</a>{` and make sure it`}{`’`}{`s in the system`}{`’`}{`s `}<inlineCode parentName="p">{`$PATH`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      